import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../config/httpConfig"
const initialState = {
    user: localStorage.getItem("busUser") ? JSON.parse(localStorage.getItem("user")) : null,
    loading: false,
    error: null,
    businessUser:[],
    newdeals:[],
}

export const getBusinesUsers = createAsyncThunk(
    "business/getBusinesUsers",
    async (params, { rejectWithValue }) => {
        try {
            const orgId = typeof params === "object" ? params?.orgId : params;
            const dealCategoryId = typeof params === "object" ? params?.dealCategoryId : null;
            let url = `/api/business/getBusinesUsers?orgId=${orgId}`;
            if (dealCategoryId) {
                url += `&dealCategoryId=${dealCategoryId}`;
            }
            const response = await axios.get(url);
            return response.response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
)


export const getBusActiveDeals = createAsyncThunk(
    "business/getBusActiveDeals",
    async (orgId, { rejectWithValue }) => {
        try {
            const response = await axios.get(`/api/business/getBusActiveDeals?orgId=${orgId}`);
            return response.response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
)


const dashboardSlice = createSlice({

    name:"dashboard",
    initialState,


    extraReducers: (builder) => {
        builder.addCase(getBusinesUsers.pending, (state) => {
            state.loading = true
            state.error = null
        })
        builder.addCase(getBusinesUsers.fulfilled, (state, action) => {
            state.loading = false
            state.businessUser = action.payload
            state.error = null
        })
        builder.addCase(getBusinesUsers.rejected, (state, action) => {
            state.loading = false
            state.businessUser = []
            state.error = action.payload
        })

        builder.addCase(getBusActiveDeals.pending, (state) => {
            state.loading = true
            state.error = null
        })
        builder.addCase(getBusActiveDeals.fulfilled, (state, action) => {
            state.loading = false
            state.newdeals = action.payload
            state.error = null
        })
        builder.addCase(getBusActiveDeals.rejected, (state, action) => {
            state.loading = false
            state.newdeals = []
            state.error = action.payload
        })
    },

    
    reducers: {}
})

// eslint-disable-next-line no-empty-pattern
export const { } = dashboardSlice.actions

export default dashboardSlice.reducer
